export default [
  {
    path: '/v2/class-attendances',
    name: 'class-attendance',
    meta: { requiresAuth: true },
    component: () => import('./views/index.vue')
  }
]
